import { ArrowRight } from 'lucide-react'
import type { ComponentType } from 'react'

type TileContent = {
  icon?: ComponentType<{ className?: string }>
  name: string
  line: string
}

/**
 * One tile in a front page's field of equal tiles.
 *
 * A tile that leads somewhere is a link, one that opens a panel is a button, and
 * one with nothing behind it is `quiet`: same frame and the same parts, so the
 * field reads as one band whatever each tile does. The arrow is drawn only on a
 * tile that can be pressed.
 */
export function Tile(
  props: TileContent &
    (
      | { href: string; onClick?: never; quiet?: never }
      | { onClick: () => void; href?: never; quiet?: never }
      | { quiet: true; href?: never; onClick?: never }
    ),
) {
  const { icon: Icon, name, line } = props
  const parts = (
    <>
      {Icon ? <Icon className="mk-tile__icon" aria-hidden /> : null}
      <span className="mk-tile__name">{name}</span>
      <span className="mk-tile__line">{line}</span>
    </>
  )
  if (props.quiet) return <div className="mk-tile mk-tile--quiet">{parts}</div>
  const go = <ArrowRight className="mk-tile__go" aria-hidden />
  return props.href !== undefined ? (
    <a className="mk-tile" href={props.href}>
      {parts}
      {go}
    </a>
  ) : (
    <button type="button" className="mk-tile" onClick={props.onClick}>
      {parts}
      {go}
    </button>
  )
}
